import {setSystemToLowercase} from './shared/serverFunctions';

/**
 * Configurations
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "Configurations": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            const typeValue = 'server';
            return {
                "type": "list",
                "method": "GET",
                "title": "Configuration",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/systemConfigurationsByType/" + system + "/" + typeValue + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            const typeValue = 'server';
            return {
                "type": "item",
                "method": "GET",
                "title": "Loyalty Account",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/systemConfigurationByTypeName/" + system + "/" + typeValue + "/" + params.id
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let configParams = populateConfigurationParams(params);
            return {
                "type": "upsert",
                "data": configParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertSystemConfiguration"
            }
        },
    }
};

/*
 * Populate values for Configurations
 */
const populateConfigurationParams = (params) => {
    delete params.data.id;

    return params;
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "Configurations"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseConfigurationResourceMap.js